import { createContext, forwardRef, type JSX } from 'react'
import { Box, useRadioGroup, BoxProps, UseRadioGroupReturn } from '@chakra-ui/react'

const RadioButtonGroupContext = createContext<UseRadioGroupReturn['getRadioProps'] | undefined>(
  undefined
)

type RadioButtonGroupProps = Omit<BoxProps, 'onChange'> & {
  name: string
  value?: string
  defaultValue?: string
  onChange?: (value: string) => void
}

export const RadioButtonGroup = forwardRef<HTMLDivElement, RadioButtonGroupProps>(
  ({ name, value, defaultValue, onChange, children, ...rest }, ref): JSX.Element => {
    const { getRootProps, getRadioProps } = useRadioGroup({
      name,
      value,
      defaultValue,
      onChange,
    })

    return (
      <RadioButtonGroupContext.Provider value={getRadioProps}>
        <Box ref={ref} {...rest} {...getRootProps()}>
          {children}
        </Box>
      </RadioButtonGroupContext.Provider>
    )
  }
)
